import axios from '@/plugins/axios'

/**
 * Sube una imagen o un PDF para usarlo dentro de un contenido enriquecido
 * (posts, artículos, términos) y devuelve el enlace con el que se incrusta.
 *
 * Todos van al mismo punto final y a la misma carpeta del servidor
 * (posts/files): solo los administradores entran al panel, y son ellos los que
 * pueden subir.
 *
 * @param {File} file
 * @returns {Promise<string>}
 */
export async function uploadEditorFile(file) {
    const formData = new FormData()
    formData.append('file', file)

    const result = await axios({
        method: 'POST',
        url: process.env.VUE_APP_API_ENDPOINT + 'posts/files',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
    })

    return editorFileUrl(result.data.filename)
}

/**
 * En producción la API cuelga del mismo dominio que la web, así que el enlace
 * se deja relativo a la raíz, como el resto de imágenes del cuerpo: sigue
 * valiendo aunque cambie el dominio.
 *
 * @param {string} filename  ruta devuelta por el servidor ('posts/files/...')
 * @returns {string}
 */
export function editorFileUrl(filename) {
    const url = process.env.VUE_APP_API_ENDPOINT + 'imagesSimple?filename=' + filename
    const origin = window.location.origin

    return url.startsWith(origin + '/') ? url.slice(origin.length) : url
}

export default uploadEditorFile
